import { getBasePath } from '../../utils/config';
import {
  IaddNotificationsTypeToUserOrContactAPIResponse,
  IgetNotificationsTypesAPIResponse,
} from './notifications.response.interface';

export const getNotificationsTypesAPI = async ({
  token,
}: {
  token: string;
}): Promise<IgetNotificationsTypesAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/notification/notifications`, params);
  const data = await response.json();
  return { response, data };
};

export const addNotificationsTypeToUserAPI = async ({
  userId,
  notificationsTypesIds,
  token,
}: {
  userId: string;
  notificationsTypesIds: Array<string>;
  token: string;
}): Promise<IaddNotificationsTypeToUserOrContactAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      entity: userId,
      notifications: notificationsTypesIds,
    }),
  };
  const response = await fetch(
    `${getBasePath()}/notification/add_user_notification`,
    params
  );
  const data = await response.json();
  return { response, data };
};

export const addNotificationsTypeToContactAPI = async ({
  contactId,
  notificationsTypesIds,
  token,
}: {
  contactId: string;
  notificationsTypesIds: Array<string>;
  token: string;
}): Promise<IaddNotificationsTypeToUserOrContactAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      entity: contactId,
      notifications: notificationsTypesIds,
    }),
  };
  const response = await fetch(
    `${getBasePath()}/notification/add_client_contact_notification`,
    params
  );
  const data = await response.json();
  return { response, data };
};
